import styled from 'styled-components';

interface DfmIssuesStyledProps {
  first?: boolean;
  isTool?: boolean;
}

export const DfmIssuesStyled = styled.section<DfmIssuesStyledProps>(
  ({ first, isTool }) => ({
    position: isTool ? 'relative' : 'static',
    display: 'flex',
    flexDirection: 'column',
    // eslint-disable-next-line no-nested-ternary
    padding: isTool
      ? '0'
      : first
      ? '2rem 3rem 1rem 3rem'
      : '2rem 3rem 0.5rem 3rem',
    top: isTool && '0',
    height: isTool && 'calc(100% - 37px)',
  }),
);
